import { render, staticRenderFns } from "./InputSmsCode.vue?vue&type=template&id=30c84bdf&scoped=true&"
import script from "./InputSmsCode.vue?vue&type=script&lang=js&"
export * from "./InputSmsCode.vue?vue&type=script&lang=js&"
import style0 from "./InputSmsCode.vue?vue&type=style&index=0&id=30c84bdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c84bdf",
  null
  
)

export default component.exports